import { isEmpty } from 'lodash';
import type { FormDefinition } from '../../format/form-definition';
import { UNTITLED_FORM } from '../new-form';
import { sameJson } from '../same-json';
import { changed, type EditFunctions } from './editContracts';
import { withoutUndefined } from './tree';

export type FormSettingsEdit =
  | { kind: 'setTitle'; title: string }
  | { kind: 'setDescription'; description: string }
  | { kind: 'setCustomAttributes'; customAttributes: Record<string, string> };

export const formSettingsEdits: EditFunctions<FormSettingsEdit> = {
  setTitle: (form, { title }) => {
    const next = title.trim() || UNTITLED_FORM;
    return changed(next === form.title ? form : withSettings(form, { title: next }));
  },
  setDescription: (form, { description }) => {
    const next = description === '' ? undefined : description;
    return changed(next === form.description ? form : withSettings(form, { description: next }));
  },
  setCustomAttributes: (form, { customAttributes }) => {
    const next = isEmpty(customAttributes) ? undefined : { ...customAttributes };
    return changed(sameJson(next, form.customAttributes) ? form : withSettings(form, { customAttributes: next }));
  },
};

type Settings = Pick<FormDefinition, 'title' | 'description' | 'customAttributes'>;

const withSettings = (form: FormDefinition, settings: Partial<Settings>): FormDefinition => {
  return withoutUndefined({ ...form, ...settings });
};
